module.exports = __webpack_public_path__ + "img/logo.3db32421.png";